
const MenuDropdowns = () => {
    const toggles = document.querySelectorAll('.main-menu__item--parent');
    const header = document.querySelector('.header');

    var navToggle = '<svg class="main-menu__link-dropdown" width="10" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M5.74.224l4 3.84a.48.48 0 11-.66.694L5.41 1.234 1.74 4.758a.48.48 0 11-.66-.695l4-3.84a.48.48 0 01.395-.13c.1.015.192.06.265.13z" fill="#CACCCF" fill-rule="nonzero"/></svg>';

    Array.prototype.forEach.call(document.querySelectorAll('.main-menu__item--parent'), function (trigger) {
        trigger.firstElementChild.insertAdjacentHTML("afterend", navToggle);
    });

    Array.from(toggles).forEach(toggle => {
        let toggleHover = false;
        let dropdownHover = false;

        const dropdown = toggle.parentElement.getElementsByClassName('main-menu__sub-menu')[0];

        toggle.addEventListener('mouseenter', e => {
            toggleHover = true;
            dropdown.classList.add('main-menu__sub-menu--active');
            toggle.classList.add('active');
            header.classList.add('header--active');
        });

        toggle.addEventListener('mouseleave', e => {
            toggleHover = false;

            setTimeout(() => {
                if (!toggleHover && !dropdownHover) {
                    dropdown.classList.remove('main-menu__sub-menu--active');
                    toggle.classList.remove('active');
                    header.classList.remove('header--active');
                }
            }, 500);
        });

        dropdown.addEventListener('mouseenter', e => {
            dropdownHover = true;
        });

        dropdown.addEventListener('mouseleave', e => {
            dropdownHover = false;

            setTimeout(() => {
                if (!toggleHover && !dropdownHover) {
                    dropdown.classList.remove('main-menu__sub-menu--active');
                    toggle.classList.remove('active');
                }
            }, 500);
        })
    })
}

export default MenuDropdowns;